<template>
  <div
    id="content"
    class="flex-column"
  >
    <p class="title">
      Dados complementares
    </p>
    <p class="text">
      Gostaríamos de conhecer um pouco mais sobre você.
    </p>
    <form
      id="rb-form"
      class="flex-column"
      @submit.prevent="submit"
    >
      <RbInput
        v-model="student.birthdate"
        label="Data de nascimento"
        type="date"
        required
        primary
      />
      <RbSelect
        v-model="student.employment"
        label="Ocupação"
        :config="{ key: 'id', title: 'title' }"
        :data="employments"
        required
        primary
      />
      <RbCep
        v-model="student.zip_code"
        label="CEP"
        required
        primary
      />
      <RbMoney
        v-model="student.income"
        label="Renda mensal"
        required
        primary
      />
    </form>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeMount, reactive, ref } from 'vue';
import { loaderStore, proposalStore, snackbarStore, stepStore } from '@/store/app';
import type { IStudentComplementary } from './interface/IStudent';
import type { IEmployment } from './interface/IEmployment';
import { getPerson } from '@/api/Person';
import { getEmployments } from '@/api/Employments';
import { complementaryStep } from '@/api/Step';
import RbInput from '../standards/RbInput.vue';
import RbSelect from '../standards/RbSelect.vue';
import RbMoney from '../standards/RbMoney.vue';
import RbCep from '../standards/RbCep.vue';

onBeforeMount(async () => {
  try {
    loaderStore().setOpen(true);
    employments.value = await getEmployments() ?? [];
    const studentData = await getPerson();
    Object.assign(student, studentData);
  } catch (error) {
    snackbarStore().alert('Tivemos um problema ao buscar seus dados!');
  } finally {
    loaderStore().setOpen(false);
  }
});

const student = reactive<IStudentComplementary>({});
const employments = ref<IEmployment[]>([]);

async function submit() {
  loaderStore().setOpen(true);
  const data = formatDataToSubmit();
  const response = await complementaryStep(data);
  if (!response) {
    loaderStore().setOpen(false);
    return snackbarStore().alert('Tivemos um problema para salvar seus dados, tente novamente!');
  }
  proposalStore().setProposal(response.proposal);
  loaderStore().setOpen(false);
  stepStore().nextStep('guarantor');
}

function formatDataToSubmit() {
  return {
    student: {
      birthdate: student.birthdate,
      employment_id: student.employment?.id,
      zip_code: String(student.zip_code).replace(/\D/g, ''),
      income: String(student.income).replace('R$ ', '').replace(',', '.')
    },
    proposal: proposalStore().getProposal()
  };
}

</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.title {
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
}

.text {
  font-size: 0.90rem;
  font-weight: 400;
  line-height: 1.45rem;
  letter-spacing: 0.025em;
  text-align: left;
  color: rgba(77, 77, 77, 1);
}

#content {
  margin: 1.3rem 1.15rem;
  gap: 16px;

  &>form {
    gap: 25px;
  }
}
</style>
